import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import About from './sections/About';
import Products from './sections/Products';
import Services from './sections/Services';
import TechStack from './sections/TechStack';
import Research from './sections/Research';
import WhyChoose from './sections/WhyChoose';
import Contact from './sections/Contact';

function App() {
  return (
    <div className="bg-gray-900 text-white">
      <Navbar />
      <main className="pt-16">
        <Hero />
        <About />
        <Products />
        <Services />
        <TechStack />
        <Research />
        <WhyChoose />
        <Contact />
      </main>
    </div>
  );
}

export default App;
